export const MicroinvertersNotReportingTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                    list</span>, and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Devices tab</span> to investigate site details.
            </li>
            <li>
                <span className="font-semibold">Ensure</span> the Gateway is on
                a <span className="font-semibold">dedicated circuit</span> near the electrical panel without
                electrical interference.
            </li>
            <li>
                <span className="font-semibold">Disconnect</span> devices on the same outlet such
                as <span className="font-semibold">power strips, UPS units, touch
                    lamps,</span> and <span className="font-semibold">battery chargers</span>.
            </li>
            <li>
                <span className="font-semibold">Relocate</span> heavy-duty appliances and workshop equipment to
                other circuits.
            </li>
            <li>
                <span className="font-semibold">Remove</span> any older CFLs to reduce interference and check if
                reporting resumes.
            </li>
        </ul>
    </div>
